import { useEffect } from "react";

import { PaymentFaild, PaymentFaildProps } from "@/types/gtm/QuoteReviewEvent";

interface ExtendedWindow extends Window {
  dataLayer?: PaymentFaild[];
}

const useGtmPaymentFaildOptions = (props: PaymentFaildProps) => {
  const { paymentFaildData, isReady } = props;

  useEffect(() => {
    const triggerPageLoadEvent = () => {
      if (paymentFaildData !== null) {
        const extendedWindow = window as ExtendedWindow;
        extendedWindow.dataLayer = extendedWindow.dataLayer ?? [];

        extendedWindow.dataLayer.push({
          ...paymentFaildData,
        });
      }
    };
    if (isReady) triggerPageLoadEvent();
    return () => {
      // Cleanup code if needed
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReady]);
};

export default useGtmPaymentFaildOptions;
